<section class="hero">
  <div class="item"
    *ngFor="let item of heroSlides; index as i;"
    [class.active]="activeHeroIndex == i"
    [class]="'hero-' + (i+1)">
    <div class="base-fit">
      <img *ngIf="item.type == 'image'" [src]="item.src" alt="">
      <video *ngIf="item.type == 'video'" playsInline autoplay muted loop oncanplay="this.play()"
        onloadedmetadata="this.muted = true">
        <source [src]="item.src" type="video/mp4">
      </video>
    </div>

    <div class="text-wrapper">
      <div>
        <h2 [innerHTML]="item.title | translate"></h2>
        <p>{{ item.text | translate }}</p>

        <div class="row">
          <div class="col-xl-4 col-md-6 col-sm-8">
            <a routerLink="/register" class="btn arrow-btn btn-primary w-100">
              {{ 'header.Register Now' | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="custom-nav" (mouseenter)="stopHeroSlider()" (mouseleave)="startHeroSlider()">
    <div class="dots">
      <span *ngFor="let item of heroSlides; index as i"
        [class.active]="activeHeroIndex == i"
        (click)="activeHeroIndex = i"
        ></span>
    </div>

    <div class="btns">
      <button class="btn btn-outline-light" (click)="navHeroSlider('prev')">
        <img src="assets/images/icons/arrow-slider-up.svg" alt=""></button>
      <button class="btn btn-outline-light" (click)="navHeroSlider('next')">
        <img src="assets/images/icons/arrow-slider-down.svg" alt=""></button>
    </div>
  </div>
</section>

<section class="categories">
  <div class="container">
    <div class="head">
      <div>
        <h2>{{ 'home.Explore Categories' | translate }}</h2>
      </div>

      <div>
        <a routerLink="/categories">
          {{ 'home.Explore all Categories' | translate }}
          <img src="assets/images/icons/arrow-left-primary.svg" alt="">
        </a>
      </div>
    </div>

    <div class="content">
      <div class="items-list">
        <div class="item-wrapper item-1">
          <a routerLink="/categories" class="item">
            <div class="base-fit">
              <img src="assets/images/home/catg-1.jpg" alt="">
            </div>

            <div class="text bg-primary">
              <div>
                <h3>{{ 'home.Content Writing' | translate }}</h3>
                <p>{{ 'home.+1000 Jobs available' | translate }}</p>
              </div>
              <div>
                <button class="btn btn-outline-light"></button>
              </div>
            </div>
          </a>
        </div>
        <div class="item-wrapper item-2">
          <a routerLink="/categories" class="item double-height">
            <div class="base-fit">
              <img src="assets/images/home/catg-2.png" alt="">
            </div>

            <div class="text bg-orange">
              <div>
                <h3>{{ 'home.Marketing' | translate }}</h3>
                <p>{{ 'home.+500 Jobs available' | translate }}</p>
              </div>
              <div>
                <button class="btn btn-outline-light"></button>
              </div>
            </div>
          </a>
        </div>
        <div class="item-3">
          <div class="item-wrapper">
            <a routerLink="/categories" class="item">
              <div class="base-fit">
                <img src="assets/images/home/catg-3.jpg" alt="">
              </div>

              <div class="text bg-secondary">
                <div>
                  <h3>{{ 'home.Development' | translate }}</h3>
                  <p>{{ 'home.+500 Jobs available' | translate }}</p>
                </div>
                <div>
                  <button class="btn btn-outline-light"></button>
                </div>
              </div>
            </a>
          </div>
          <div class="item-wrapper">
            <a routerLink="/categories" class="item">
              <div class="base-fit">
                <img src="assets/images/home/catg-4.jpg" alt="">
              </div>

              <div class="text bg-light-blue">
                <div>
                  <h3>{{ 'home.Finance' | translate }}</h3>
                  <p>{{ 'home.+500 Jobs available' | translate }}</p>
                </div>
                <div>
                  <button class="btn btn-outline-light"></button>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="clients">
  <h2 class="title">{{'home.Our Clients' | translate}}</h2>
  <swiper-container class="slider" #clientsSwiper
  [slidesPerView]="'auto'"
  [loop]="true"
  autoplay-delay="0"
  [autoplay]="{ delay: 0, disableOnInteraction: false, pauseOnMouseEnter: false }"
  [speed]="5000"
  [freeMode]="true"
  [grabCursor]="true">
    <swiper-slide class="item" *ngFor="let img of clients">
      <img [src]="img" alt="">
    </swiper-slide>
    <swiper-slide class="item" *ngFor="let img of clients">
      <img [src]="img" alt="">
    </swiper-slide>
  </swiper-container>
</section>

<section class="get-job">
  <div class="container ps-1 ps-md-4">
    <div class="row g-3">
      <div class="col-sm-6">
        <h2 class="title" [innerHTML]="'home.get gob title' | translate"></h2>
        <p>
          {{ 'home.get gob text' | translate }}
        </p>
        <div class="row">
          <div class="col-md-6 col-8">
            <a routerLink="/register" class="btn arrow-btn btn-primary w-100">
              {{ 'header.Register Now' | translate }}
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <img class="w-100" [src]="'assets/images/home/get-job-'+lang+'.png'" alt="">
      </div>
    </div>

    <div class="job-register">
      <div class="img-container">
        <img src="assets/images/home/job.jpg" alt="">
      </div>
      <div class="row">
        <div class="col-md-6 col-sm-8">
          <h2>{{ 'home.Register Now and Apply for' | translate }}</h2>
          <span class="highlight">{{ 'home.Best Match Jobs' | translate }}</span>
          <p>{{ 'home.Take an action Today! Register now and seize the opportunity to apply for the best match jobs.' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</section>
